import React from 'react';
import '../../styles/productDetail.css';

/**
 * Skeleton component mimicking redesigned desktop layouts and mobile layouts.
 * Uses pulse shimmer effects to signify content loading.
 */
const ProductSkeleton = () => {
  return (
    <div className="product-detail-container">
      {/* Breadcrumb Skeleton */}
      <div className="skeleton-breadcrumb skeleton-pulse" />

      {/* Main Grid Wrapper */}
      <div className="product-layout-grid">
        {/* Panel 1: Gallery component skeleton */}
        <div className="product-layout-gallery-group">
          {/* Main display container skeleton */}
          <div className="gallery-display-container">
            <div className="skeleton-main-image skeleton-pulse" />
          </div>

          {/* Horizontal thumbnail slider skeleton */}
          <div className="skeleton-horizontal-thumbnail-rail">
            <div className="skeleton-horizontal-thumbnail-item skeleton-pulse" />
            <div className="skeleton-horizontal-thumbnail-item skeleton-pulse" />
            <div className="skeleton-horizontal-thumbnail-item skeleton-pulse" />
            <div className="skeleton-horizontal-thumbnail-item skeleton-pulse" />
          </div>
        </div>

        {/* Panel 2: Info text card panel skeleton */}
        <div className="info-content-panel">
          <div className="skeleton-text-title skeleton-pulse" />
          
          <div className="skeleton-text-price skeleton-pulse" />
          <div className="skeleton-text-moq skeleton-pulse" />

          {/* Badges Skeleton row */}
          <div className="skeleton-badge-row">
            <div className="skeleton-badge-item skeleton-pulse" />
          </div>

          {/* CTA Buttons Skeleton row */}
          <div className="skeleton-badge-row" style={{ height: '54px', width: '100%', display: 'flex', gap: '16px' }}>
            <div className="skeleton-badge-item skeleton-pulse" style={{ flex: '1', height: '100%' }} />
            <div className="skeleton-badge-item skeleton-pulse" style={{ flex: '1', height: '100%' }} />
          </div>

          {/* Description Skeleton paragraphs */}
          <div className="skeleton-description-lines">
            <div className="skeleton-desc-line full skeleton-pulse" />
            <div className="skeleton-desc-line medium skeleton-pulse" />
            <div className="skeleton-desc-line short skeleton-pulse" />
          </div>

          {/* Highlights Skeleton box */}
          <div className="skeleton-highlights-box skeleton-pulse" />
        </div>
      </div>
    </div>
  );
};

export default ProductSkeleton;
